import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { ChevronDown, Building2 } from "lucide-react";

export default function CustomerSelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (v: string) => void;
}) {
  const { data } = useQuery({ queryKey: ["customers"], queryFn: api.customers });

  return (
    <div className="relative inline-block max-w-[60vw]">
      <Building2 className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="max-w-[60vw] cursor-pointer appearance-none truncate rounded-full border border-border bg-card py-1.5 pl-9 pr-8 text-sm font-medium shadow-sm outline-none transition-colors hover:bg-muted focus:ring-2 focus:ring-primary/40"
        aria-label="분야 선택"
      >
        <option value="">분야 전체</option>
        {data?.groups.map((g) => (
          <optgroup key={g.shelf} label={g.shelf}>
            {g.items.map((it) => (
              <option key={it.value} value={it.value}>
                {it.label}
              </option>
            ))}
          </optgroup>
        ))}
      </select>
      <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
    </div>
  );
}
